/*
 * Cookie Consent.
 */
window.wpCookieConsent = (function () {

	var COOKIE_VALUE = 1;

	function consentWithCookies() {
		setCookie('cookie_consent', COOKIE_VALUE, 365 * 20);
		hideCookieDialog();
	}

	function cookieExists(name) {
		return (document.cookie.split('; ').indexOf(name + '=' + COOKIE_VALUE) !== -1);
	}

	function hideCookieDialog() {
		var dialogs = document.getElementsByClassName('cookie-consent');

		for (var i = 0; i < dialogs.length; ++i) {
			dialogs[i].style.display = 'none';
		}
	}

	function showCookieDialog() {
		var dialogs = document.getElementsByClassName('cookie-consent');

		for (var i = 0; i < dialogs.length; ++i) {
			dialogs[i].style.display = 'flex';
		}
	}

	function setCookie(name, value, expirationInDays) {
		var date = new Date();
		date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
		document.cookie = name + '=' + value + '; ' + 'expires=' + date.toUTCString() + ';path=/';
	}

	if (cookieExists('cookie_consent')) {
		hideCookieDialog();
		spaceCookieDialog();
	} else {
		showCookieDialog();
		spaceCookieDialog();
	}

	var buttons = document.getElementsByClassName('js-cookie-consent-agree');

	for (var i = 0; i < buttons.length; ++i) {
		buttons[i].addEventListener('click', consentWithCookies);
	}

	function spaceCookieDialog() {
		var cookie = $('.cookie-consent'),
			cookieHeight = cookie.outerHeight(),
			quickActionBar = $('.js-quick-action-bar'),
			quickActionBarHeight = quickActionBar.outerHeight(),
			button = $('.js-cookie-consent-agree');

		if (cookie.is(':visible')) {
			$('body').css('padding-bottom', cookieHeight);

			button.on('click', function () {
				if (quickActionBar.is(':visible')) {
					$('body').css('padding-bottom', quickActionBarHeight);
				} else {
					$('body').css('padding-bottom', 0);
				}
			});
		} else if (quickActionBar.is(':visible')) {
			$('body').css('padding-bottom', quickActionBarHeight);
		} else {
			$('body').css('padding-bottom', 0);
		}

		$(window).on('resize', function () {
			if (cookie.is(':visible')) {
				var cookieHeight = cookie.outerHeight();
				$('body').css('padding-bottom', cookieHeight);
			} else if (quickActionBar.is(':visible')) {
				var quickActionBarHeight = quickActionBar.outerHeight();
				$('body').css('padding-bottom', quickActionBarHeight);
			} else {
				$('body').css('padding-bottom', 0);
			}
		});
	}

	return {
		consentWithCookies: consentWithCookies,
		hideCookieDialog: hideCookieDialog,
		showCookieDialog: showCookieDialog,
		spaceCookieDialog: spaceCookieDialog
	};
})();
